exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-button--small {\n    padding: 9px 15px!important;\n}\n.el-table tr {\n    background-color: #e6e6e6;\n}\n", ""]);

// exports
